const API_URL = process.env.REACT_APP_API_URL;

/**
 * Create a PayPal onboarding link for the current user.
 * @param {string} token - Authentication token.
 * @returns {Promise<Object>} - PayPal onboarding link.
 */
export const createPaypalAccountLink = async (token) => {
  try {
    const response = await fetch(`${API_URL}/paypal/account_link`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) {
      const errorMessage = await response.text();
      throw new Error(errorMessage || 'Failed to create PayPal onboarding link');
    }
    return await response.json();
  } catch (error) {
    console.error('Error creating PayPal onboarding link:', error);
    throw error;
  }
};
